module.exports = __webpack_public_path__ + "static/media/about_layout.76fc18d8.png";